import styled from 'styled-components';

export const Tab = styled.div.withConfig({ displayName: '-Tab' })`
	flex-basis: 50%;
	flex-grow: 0;
	flex-shrink: 0;
	text-align: center;
	background-color: ${props => props.active ? "#f4f4f4" : "#e1e1e1"};
	border-right: 1px solid #C4C4C4;
	border-bottom: 1px solid ${props => props.active ? "#f4f4f4" : "#C4C4C4"};
	color: ${props => props.disabled ? "#999999" : "#555555"};
	font-size: 12px;
	line-height: 15px;
	font-weight: bold;
	padding: 7px;
	cursor:  ${props => props.disabled ? "not-allowed" : "pointer"};
`;
